module.exports = __webpack_public_path__ + "static/media/technology-transforming-data.57ca1cc2.webp";